export default "/images/589afc2fc542b668012109f6354fadbf.avif";